import { Tooltip } from "@mui/material";
import type { FormRow } from "../types";

export const StatusCellRenderer = (props: { data?: FormRow }) => {
  const row = props.data;
  if (!row) return null;
  const items: React.ReactNode[] = [];

  if (row.errorMessage) {
    const isError = row.errorSeverity !== "warning";
    items.push(
      <Tooltip key="err" title={row.errorMessage} arrow>
        <span
          style={{
            color: isError ? "#ff1744" : "#ff9800",
            fontWeight: 900,
            fontSize: 16,
          }}
        >
          ⚠
        </span>
      </Tooltip>
    );
  }
  if (row.isDirty) {
    items.push(
      <span key="dirty" title="Pending change" style={{ color: "#ffb74d" }}>
        ●
      </span>
    );
  }
  if (row.required && (row.value === undefined || row.value === null || row.value === "")) {
    items.push(
      <span
        key="req"
        style={{
          color: "#ff1744",
          fontSize: 11,
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        required
      </span>
    );
  } else if (!row.required) {
    items.push(
      <span key="opt" style={{ color: "#5d6c8a", fontSize: 11, letterSpacing: 0.4 }}>
        optional
      </span>
    );
  }

  return (
    <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}>
      {items}
    </span>
  );
};
